export default "252be6b3e5b35776.svg"